import axios from 'axios'
import { useState } from 'react'

type PostCodeRes = {
  results: { address1: string; address2: string; address3: string }[]
  status: number
}

/**
 * 郵便番号から住所を取得する関数を提供する hooks
 * @returns isLoading データを取得中かどうか
 * @returns fetchAddressFromPostCode 関数
 */
export const useFetchAddressFromPostCode = (): {
  isLoading: boolean
  fetchAddressFromPostCode: (postcode: number) => Promise<PostCodeRes>
} => {
  const [isLoading, setIsLoading] = useState(false)

  const fetchAddressFromPostCode = async (
    postcode: number,
  ): Promise<PostCodeRes> => {
    setIsLoading(true)
    const { data } = await axios.get(
      `https://zip-cloud.appspot.com/api/search?zipcode=${postcode}`,
    )
    setIsLoading(false)
    return data
  }

  return {
    isLoading,
    fetchAddressFromPostCode,
  }
}
